package com.clany.backoffice.data.repository

import com.clany.backoffice.model.UserType
import kotlinx.serialization.Serializable

@Serializable
data class UpdateUserRequest(
    val id: String,
    val firstName: String,
    val lastName: String,
    val type: UserType,
    val locale: String,
    val linkedMemberId: String?,
    val pictureUrl: String?,
    val shouldUpdateTyc: Boolean
)

@Serializable
data class UpdateRoleRequest(val role: String)
